import React, { useCallback, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, MessageSquareIcon } from 'lucide-react';
import { testimonials, Testimonial } from '../data/content';
function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-gold/35 bg-navy p-6 shadow-sm shadow-black/25" data-id="element-179" data-mp="3azjetzqo6od9">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-180" data-mp="370k7k8hgufin">
        <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-181" data-mp="31yl5r31djqnt" />
      </span>
      <p className="mt-4 flex-1 text-sm leading-relaxed text-white/80" data-id="element-182" data-mp="2x1kzos4iynwp">“{testimonial.text}”</p>
      <div className="mt-6" data-id="element-183" data-mp="2s2rwbsiycda9">
        <p className="text-sm font-bold text-white" data-id="element-184" data-mp="2s3jk4h6b56pz">{testimonial.name}</p>
        <p className="text-xs text-white/60" data-id="element-185" data-mp="v859fwccnb29">{testimonial.source}</p>
      </div>
    </article>;
}
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const activeTestimonial = testimonials[index % testimonials.length];
  const go = useCallback((direction: number) => {
    setIndex(current => (current + direction + testimonials.length) % testimonials.length);
  }, []);
  return <section className="w-full bg-navy-mid px-5 py-12 sm:py-20" data-id="element-186" data-mp="79bols47aq2n">
      <div className="mx-auto max-w-5xl" data-id="element-187" data-mp="c623wd86lhn0">
        <div className="mx-auto max-w-2xl text-center" data-id="element-188" data-mp="c73nj639jcgc">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-189" data-mp="zw66ch9mvbcf">
            What Customers Are Saying
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-190" data-mp="14xlp22oc95rn">
            Real feedback shared by customers on Facebook.
          </p>
        </div>
        <div className="mt-10 hidden gap-6 md:grid md:grid-cols-3" data-id="element-191" data-mp="v4xz9rvs022f">
          {testimonials.map((testimonial, cardIndex) => <TestimonialCard key={cardIndex} testimonial={testimonial} data-id="element-192" data-mp="1itqsvhoxdxtv" data-mpi={cardIndex} />)}
        </div>
        <div className="mt-10 md:hidden" data-id="element-193" data-mp="1nnlfasvx0qwn">
          <div className="relative overflow-hidden" data-id="element-194" data-mp="1xhqxbmoczosy">
            <AnimatePresence mode="wait" data-id="element-195" data-mp="1xhh6xxzejfmq">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-196" data-mp="1sj5urglmwt1c">
                <TestimonialCard testimonial={activeTestimonial} data-id="element-197" data-mp="1jkkjm6ihsgal" />
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="mt-5 flex items-center justify-between" data-id="element-198" data-mp="19s6a2rl6a5dv">
            <button type="button" onClick={() => go(-1)} aria-label="Previous review" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-gold" data-id="element-199" data-mp="14tbkn6sp9iks">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="vs3yfn3gk872" />
            </button>
            <div className="flex gap-2" data-id="element-201" data-mp="quvd5dn0jo1l">
              {testimonials.map((_, itemIndex) => <button type="button" key={itemIndex} onClick={() => setIndex(itemIndex)} aria-label={`Go to review ${itemIndex + 1}`} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${itemIndex === index ? 'w-6 bg-gold' : 'w-2 bg-gold/35'}`} data-id="element-202" data-mp="32g48x5kn8gmo" data-mpi={itemIndex} />)}
            </div>
            <button type="button" onClick={() => go(1)} aria-label="Next review" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-gold" data-id="element-203" data-mp="2op97ufgdz3tn">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-204" data-mp="2xj43mwvmbhwm" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}